import type { CommandBarAction } from '../store/schema/CommandBarAction';
import defaultCommandBarConfig from './defaultCommandBarConfig';

export function getCommandBarActionFromString(
    actionsString: string | undefined
): CommandBarAction[] {
    if (!actionsString) {
        return defaultCommandBarConfig.slice();
    }
    return actionsString.split(',').map(Number) as CommandBarAction[];
}
